import styled from 'styled-components'

const RULES = [
    { regex: /<[^>]+>/g, replacement: '' }, // links
    { regex: /\[([^[]+)\]\(([^)]+)\)/g, replacement: "<a href='$2' target='_blank'>$1</a>" }, // links
    { regex: /(\*\*|__)(.*?)\1/g, replacement: '<strong>$2</strong>' }, // bold
    { regex: /(\*|_)(.*?)\1/g, replacement: '<em>$2</em>' }, // emphasis
]

const renderMarkdown = (text) => {
    let html = text
    RULES.forEach(({ regex, replacement }) => {
        html = html.replace(regex, replacement)
    })

    return html.trim()
}

const Container = styled.span`
    display: block;

    strong,
    em,
    a {
        display: inline;
        margin: 0;
        padding: 0;
    }

    a {
        color: ${(props) => props.theme.primaryColor};
    }
`

const StoryCaption = ({ caption }) => <Container dangerouslySetInnerHTML={{ __html: renderMarkdown(caption) }} />

export default StoryCaption
